// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const registrikood: CountryValidator<"EE"> =
  createValidator("ee.registrikood", 62);

export default registrikood;
export const compact = registrikood.compact;
export const format = registrikood.format;
export const validate = registrikood.validate;
export const generate = (): string =>
  registrikood.generate?.() ??
  (() => {
    throw new Error(
      "Validator ee.registrikood cannot generate values",
    );
  })();
